import { CJM_WIDGET_TITLE_KEYS } from '@/components/Metrics/config'

export const processCJMWidgetKey = (key: string) =>
  CJM_WIDGET_TITLE_KEYS[key as keyof typeof CJM_WIDGET_TITLE_KEYS] ?? key
